import { FlagProvider, IConfig } from "@unleash/proxy-client-react";
import invariant from "tiny-invariant";

invariant(
  process.env.UNLEASH_PROXY_URL,
  "UNLEASH_PROXY_URL environment variable is required",
);
invariant(
  process.env.UNLEASH_CLIENT_KEY,
  "UNLEASH_CLIENT_KEY environment variable is required",
);
invariant(
  process.env.UNLEASH_APP_NAME,
  "UNLEASH_APP_NAME environment variable is required",
);

const config: IConfig = {
  appName: process.env.UNLEASH_APP_NAME,
  clientKey: process.env.UNLEASH_CLIENT_KEY,
  environment: process.env.UNLEASH_ENVIRONMENT,
  refreshInterval: 15,
  url: process.env.UNLEASH_PROXY_URL,
};

const FeatureFlagProvider = ({
  children,
  userId,
}: React.PropsWithChildren<{ userId: string }>) => (
  <FlagProvider config={{ ...config, context: { userId } }}>
    {children}
  </FlagProvider>
);

export { FeatureFlagProvider };
